import React from 'react';
import { makeStyles } from '@material-ui/core/';

const useStyles = makeStyles((theme) => ({
	countLbl: {
		color: 'blue',
	},
}));

const FilterLabel = ({ message, count }) => {
	const classes = new useStyles();
	return (
		<span>
			{message} <label className={classes.countLbl}>{`(${count})`}</label>
		</span>
	);
};

export default FilterLabel;
